import { Primitive } from '../Primitive';
import { Type } from '../Type';
import { Point3D } from './Point3D';
export class Sphere extends Primitive {
    center;
    radius;
    constructor(center, radius) {
        super(Type.Sphere);
        let centerValue;
        switch (true) {
            case center instanceof Point3D:
                centerValue = center;
                break;
            case Array.isArray(center):
                center = center;
                centerValue = new Point3D(center[0], center[1], center[2]);
                break;
            default:
                center = center;
                centerValue = new Point3D(center.x, center.y, center.z);
        }
        this.center = centerValue;
        this.radius = radius;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3BoZXJlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi90eXBlcy9nZW9tZXRyeV8zZC9TcGhlcmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGNBQWMsQ0FBQTtBQUN4QyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sU0FBUyxDQUFBO0FBRTlCLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxXQUFXLENBQUE7QUFFbkMsTUFBTSxPQUFPLE1BQU8sU0FBUSxTQUFTO0lBQzFCLE1BQU0sQ0FBUztJQUNmLE1BQU0sQ0FBUTtJQUV2QixZQUNFLE1BRzRCLEVBQzVCLE1BQWM7UUFFZCxLQUFLLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBRWxCLElBQUksV0FBb0IsQ0FBQTtRQUN4QixRQUFRLElBQUksRUFBRSxDQUFDO1lBQ2IsS0FBSyxNQUFNLFlBQVksT0FBTztnQkFDNUIsV0FBVyxHQUFHLE1BQWlCLENBQUE7Z0JBQy9CLE1BQUs7WUFDUCxLQUFLLEtBQUssQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDO2dCQUN4QixNQUFNLEdBQUcsTUFBa0MsQ0FBQTtnQkFDM0MsV0FBVyxHQUFHLElBQUksT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsRUFBRSxNQUFNLENBQUMsQ0FBQyxDQUFDLEVBQUUsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUE7Z0JBQzFELE1BQUs7WUFDUDtnQkFDRSxNQUFNLEdBQUcsTUFBNkMsQ0FBQTtnQkFDdEQsV0FBVyxHQUFHLElBQUksT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFDLEVBQUUsTUFBTSxDQUFDLENBQUMsRUFBRSxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUE7UUFDM0QsQ0FBQztRQUVELElBQUksQ0FBQyxNQUFNLEdBQUcsV0FBVyxDQUFBO1FBQ3pCLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFBO0lBQ3RCLENBQUM7Q0FDRiJ9